/* Completa tu rutina · carrito. Marca: snippets/rutina-carrito.liquid. Eleccion: assets/rutina-motor.js
   Es un elemento propio para que funcione cada vez que el tema vuelve a dibujar el cajon del carrito. */
(function () {
  if (window.customElements.get('ll-rutina-carrito')) return;

  function lista(s, sep) { return String(s || '').split(sep).map(function (x) { return x.trim(); }).filter(Boolean); }

  class LlRutinaCarrito extends HTMLElement {
    connectedCallback() {
      var caja = this.querySelector('[data-rc-sug]');
      if (!caja || this.dataset.listo) return;
      this.dataset.listo = '1';
      var R = window.LlRutina;
      if (!R) { caja.remove(); return; }
      var el = this;

      R.sugerir({
        tags: lista(this.dataset.tags, '|'),
        vendors: lista(this.dataset.vendors, '|'),
        pasos: lista(this.dataset.pasos, ','),
        excluir: lista(this.dataset.excluir, ',')
      }).then(function (res) {
        if (!el.isConnected) return;
        if (!res.length) { caja.remove(); return; }
        caja.innerHTML = '';
        res.forEach(function (r) { caja.appendChild(el.tarjeta(r.p, r.paso)); });
      });

      caja.addEventListener('click', function (e) {
        var b = e.target.closest('.rc-add');
        if (!b || b.disabled) return;
        b.disabled = true;
        b.classList.add('is-cargando');
        b.querySelector('span').textContent = 'Agregando';
        R.agregar([b.dataset.variant]).then(function () {
          // Si el tema no volvio a dibujar el carrito, al menos confirma.
          if (b.isConnected) { b.classList.remove('is-cargando'); b.querySelector('span').textContent = 'Agregado'; }
        }).catch(function (err) {
          b.disabled = false;
          b.classList.remove('is-cargando');
          b.querySelector('span').textContent = 'Agregar';
          var msg = (err && err.message && err.message !== 'cart') ? err.message : 'No pudimos agregarlo. Intenta de nuevo.';
          document.dispatchEvent(new CustomEvent('toast:show', { detail: { message: msg, tone: 'error' } }));
        });
      });
    }

    tarjeta(p, paso) {
      var d = document.createElement('div');
      d.className = 'rc-item';

      var fig = document.createElement('a');
      fig.className = 'rc-fig';
      fig.href = p.url;
      fig.tabIndex = -1;
      fig.setAttribute('aria-hidden', 'true');
      if (p.image) {
        var im = document.createElement('img');
        im.src = p.image; im.alt = ''; im.loading = 'lazy'; im.width = 120; im.height = 120;
        fig.appendChild(im);
      }
      d.appendChild(fig);

      var info = document.createElement('div');
      info.className = 'rc-info';
      var k = document.createElement('span');
      k.className = 'rc-pk';
      k.textContent = 'Paso ' + paso.n + ' · ' + paso.nombre;
      var a = document.createElement('a');
      a.className = 'rc-nombre';
      a.href = p.url;
      a.textContent = p.title;
      var pr = document.createElement('span');
      pr.className = 'rc-precio';
      pr.textContent = window.LlRutina.money(p.price);
      info.appendChild(k); info.appendChild(a); info.appendChild(pr);
      d.appendChild(info);

      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'rc-add';
      b.dataset.variant = p.variantId;
      b.setAttribute('aria-label', 'Agregar ' + p.title + ' al carrito');
      b.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 6v12M6 12h12"/></svg><span>Agregar</span>';
      d.appendChild(b);
      return d;
    }
  }

  window.customElements.define('ll-rutina-carrito', LlRutinaCarrito);
})();
